/* eslint-disable react/jsx-wrap-multilines */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import { linkedAdjustmentsShape } from '../../../../../common/components/proptypes/commonProptypes';
import { getLinksDescriptor } from '../AdjustmentGroup/AdjustmentGroupHelpers';
import { LinkedAdjustmentLinkIcon } from '../LinkedAdjustmentLinkIcon';
import LinkedAdjustmentPopover from './LinkedAdjustmentPopover';
import './LinkedAdjustmentsOverlayTrigger.scss';

const AdjustmentLinkOverlayTrigger = ({
  adjustmentLinks,
  projectId,
  handleKeyDown,
  show,
  onToggle,
}) => {
  const [selected, setSelected] = useState(false);
  const linksDescriptor = getLinksDescriptor(adjustmentLinks);

  if (!linksDescriptor.hasLinks) {
    return null;
  }

  return (
    <OverlayTrigger
      rootClose
      trigger="click"
      placement="top-end"
      overlay={
        <LinkedAdjustmentPopover
          adjustmentLinks={adjustmentLinks}
          projectId={projectId}
        />
      }
      show={show}
      onToggle={(visible) => {
        setSelected(visible);
        onToggle(visible);
      }}
    >
      <div className="adjustment-link" data-testid="adjustment-link">
        <LinkedAdjustmentLinkIcon
          isSelected={selected}
          isBroken={linksDescriptor.hasBrokenLinks}
          handleKeyDown={handleKeyDown}
          isVisible={show}
        />
      </div>
    </OverlayTrigger>
  );
};

AdjustmentLinkOverlayTrigger.propTypes = {
  adjustmentLinks: PropTypes.arrayOf(linkedAdjustmentsShape),
  projectId: PropTypes.string.isRequired,
};

AdjustmentLinkOverlayTrigger.defaultProps = {
  adjustmentLinks: [],
};

export default AdjustmentLinkOverlayTrigger;
